export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/entries.js
// module id = 403
// module chunks = 7